module.exports = __webpack_public_path__ + "08_long_yellow.b2b1eb37.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/08_long_yellow.png
// module id = Hq2h
// module chunks = 0